module.exports = __webpack_public_path__ + "static/media/opt-in.f63522f3.svg";